// extracted by mini-css-extract-plugin
module.exports = {"paragraph-detail":"styles_paragraph-detail__IZKtN","nr-container":"styles_nr-container__I5hdQ","image":"styles_image__YCaaA","h3":"styles_h3__neqIO","h4":"styles_h4__H6Ie6"};